export default "__VITE_ASSET__DY1gvt9h__"